import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class ArticleRankingSource extends ApplicationRecord {
  static jsonapiType = "article_ranking_sources";

  @Attr() blockAds: boolean;

  @Attr({ persist: false }) createdAt: string;

  @Attr() defaultEnabled: boolean;

  @Attr() emulateMobile: boolean;

  @Attr() enabled: boolean;

  @Attr() group: string;

  @Attr() logoData: string;

  @Attr() logoUrl: string;

  @Attr() name: string;

  @Attr() region: string;

  @Attr() section: string;

  @Attr() url: string;
}

export default ArticleRankingSource;
